var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-select',{attrs:{"value":_vm.value,"placeholder":`${_vm.$tc('select')} ${_vm.$tc('rol', 2)}`,"expanded":"","disabled":"disabled"},on:{"input":_vm.onSelect}},[_c('option',{domProps:{"value":12}},[_vm._v(" "+_vm._s(_vm.$tc('Administrator'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }